
    <div class="modal-header">
      <button *ngIf="showClose" type="button" class="close" data-dismiss="modal" aria-label="Close"
              (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
      <ng-content></ng-content>
    </div>
  